import React, { useState } from "react";
import { SovosTab, SovosTabs } from "mosaic-react";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import {
    filteredNavigationByModulesForNestedLinks,
    tabsRepositoryNavigationByModules,
} from "../../controllers/Repository/navigation";
import { hydrateRoute } from "colbi_web_ui/lib/utils";

const buildTabs = (path, lastPart) => {
    const splitArray = path.split("/");
    splitArray[splitArray.length - 1] = lastPart;
    return splitArray.join("/");
};

const RepositoryTabs = () => {
    const { history, location, i18n, modules, params } = useGlobalValue();
    const [selectedTab, setSelectedTab] = useState(
        buildTabs(location.pathname, location.pathname.split("/")?.pop()),
    );

    const repositoryNavigation = filteredNavigationByModulesForNestedLinks(
        modules,
        tabsRepositoryNavigationByModules,
    );

    const tabs = repositoryNavigation.map((elem, index) => {
        const { name, icon: Icon, to } = elem;
        return (
            <SovosTab
                key={index}
                value={hydrateRoute(to, params)}
                icon={<Icon />}
                label={i18n`${name}`}
            />
        );
    });

    return (
        <SovosTabs
            onChange={(_, value) => {
                setSelectedTab(value);
                history.push(value);
            }}
            value={selectedTab}
        >
            {tabs}
        </SovosTabs>
    );
};

export default RepositoryTabs;
